module.exports = __webpack_public_path__ + "img/wandile-makhubu.01d7e25f.png";